"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Table_1 = tslib_1.__importDefault(require("@mui/material/Table"));
const TableBody_1 = tslib_1.__importDefault(require("@mui/material/TableBody"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const TableRow_1 = tslib_1.__importDefault(require("@mui/material/TableRow"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const getStyles = ({ props }) => ({
    keyValueTableRow: {
        borderBottom: props?.hideRowLines ? "none" : "1px solid rgba(224, 224, 224, 1)",
    },
    hideRowLine: {
        borderBottom: "none",
    },
    keyValueTableCell: {
        borderBottom: "none",
        maxWidth: props?.valueMaxWidth,
        padding: (theme) => (props?.dense ? theme.spacing(0.5, 1, 0.5, 1) : theme.spacing(1)),
        verticalAlign: "top",
    },
    keyValueTableHeadCell: (theme) => ({
        borderBottom: "none",
        color: theme.palette.grey[600],
        maxWidth: props?.keyMaxWidth,
        padding: props?.dense ? theme.spacing(0.5, 1, 0.5, 1) : theme.spacing(1),
        verticalAlign: "top",
    }),
});
/**
 *  The KeyValueTable is an extended table version of MUI v4 that displays pairs of keys (left) and values (right).
 *  By default the Keys are grey, while the values are black. Use these defaults as much as possible to keep consistency across Argus.
 *  If necessary, these can be overridden by setting the keyTypographyProps or valueTypographyProps. Do ask whether it is necessary to override and change the design before doing it though.
 *  By default, we have row borders with the option to hide the last row border. These can also be changed through the "hideRowLines" and "hideLastRowLine" props.
 *
 * @remarks ### Not supported yet
 *  These features are noe supported within our table:
 *  * Alternating background row colors
 *  * Key/value displayed in pairs underneath each other
 *  * Automatic table-layout of more than one table
 *  * Only key value pairs are supported within the table, and no sectioning or headers.
 *
 * @example ### Basic example
 * How to set the keyTypographyProps inline or with a class.
 * ```
 * <KeyValueTable keyTypographyProps={{ color: "textPrimary", className: classes.keyTypo }} data={data} />
 *```
 * To run the basic example of this:
 *
 * ```
 * ./server.js 1_KeyValueTable
 * ```
 *
 */
const KeyValueTable = (props) => {
    const { data, keyMaxWidth, valueMaxWidth, hideLastRowLine, hideRowLines, keyTypographyProps, valueTypographyProps, tableRowProps, dense = false, ...rest } = props;
    const styles = getStyles({ props: { keyMaxWidth, valueMaxWidth, hideRowLines, dense } });
    const tableRowClassName = (index) => hideLastRowLine && index === data.length - 1 ? styles.hideRowLine : styles.keyValueTableRow;
    return (react_1.default.createElement(Table_1.default, { ...rest },
        react_1.default.createElement(TableBody_1.default, null, data.map(({ key, value }, index) => {
            return (react_1.default.createElement(TableRow_1.default, { sx: tableRowClassName(index), key: index, ...tableRowProps },
                react_1.default.createElement(TableCell_1.default, { variant: "head", scope: "row", padding: "normal", sx: styles.keyValueTableHeadCell },
                    typeof key === "string" || typeof key === "number" ? (react_1.default.createElement(Typography_1.default, { ...keyTypographyProps }, key)) : (key),
                    " "),
                react_1.default.createElement(TableCell_1.default, { sx: styles.keyValueTableCell },
                    typeof value === "string" || typeof value === "number" ? (react_1.default.createElement(Typography_1.default, { ...valueTypographyProps }, value)) : (value),
                    " ")));
        }))));
};
exports.default = KeyValueTable;
